import { render, staticRenderFns } from "./ManagerLedger.vue?vue&type=template&id=e3966754&scoped=true&"
import script from "./ManagerLedger.vue?vue&type=script&lang=js&"
export * from "./ManagerLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3966754",
  null
  
)

export default component.exports